export const TRACK_ALERT_DETAIL_DEFAULT_TEMPLATE = [
  {
    op: 'ui',
    name: 'Stack',
    direction: 'column',
    flex: [2, 2],
    spacing: 2,
    sx: { minWidth: 0 },
    children:
      [
        {
          op: 'context',
          path: 'alertCard',
        },
        {
          op: 'context',
          path: 'thingPersonGroupsCard',
        },
        {
          op: 'context',
          path: 'thingCard',
        },
        {
          op: 'context',
          path: 'personCard',
        },
      ],
  },
  {
    op: 'ui',
    name: 'Stack',
    direction: 'column',
    flex: [3, 3],
    spacing: 2,
    children:
      [
        {
          op: 'context',
          path: 'alertMap',
        },
        {
          op: 'context',
          path: 'mediaCard',
        },
      ],
  },
];
